<div class="login-card">
  <span class="recovery-title">Secure your account</span>
  <span class="recovery-heading">
    Set at least one of the following. You can skip the ones you don't want.
  </span>

  <div class="recovery-steps">
    @for (step of steps; track step.index; let last = $last) {
    <div class="recovery-step" [class.active]="recovery.step === step.index"
      [class.done]="isSet(step.key)" (click)="stepSelected.emit(step.index)">
      <div class="step-circle">
        @if (isSet(step.key)) {
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6"
          stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="m5 12.5 4.5 4.5L19 7.5" />
        </svg>
        } @else {
        {{ step.index }}
        }
      </div>
      <span class="step-label">{{ step.label }}</span>
    </div>
    @if (!last) {
    <div class="step-connector" [class.done]="isSet(step.key)"></div>
    }
    }
  </div>

  <form [formGroup]="form" style="display: flex; flex-direction: column; gap: 24px">
    @if (recovery.step === 1) {
    @if (isSet('password')) {
    <div class="recovery-done-banner">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
        stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <circle cx="12" cy="12" r="10" />
        <path d="m8.5 12.5 2.5 2.5 5-5.5" />
      </svg>
      <span>Password has been set</span>
    </div>
    } @else {
    <div class="form-group">
      <label for="recPassword">New password</label>
      <input [type]="isPasswordVisible ? 'text' : 'password'" id="recPassword" formControlName="password"
        placeholder="Enter password" style="text-transform: none !important" autocomplete="new-password" />
    </div>
    <div class="form-group">
      <label for="recConfirmPassword">Confirm password</label>
      <input [type]="isPasswordVisible ? 'text' : 'password'" id="recConfirmPassword"
        formControlName="confirmPassword" placeholder="Re-enter password" style="text-transform: none !important"
        autocomplete="new-password" />
    </div>
    <button type="button" class="login-btn" [disabled]="isLoading" (click)="passwordSet.emit()">
      @if (isLoading) {
      <span class="spinner" role="status" aria-label="Loading"></span>
      } @else { Set Password }
    </button>
    }
    }

    @if (recovery.step === 2) {
    @if (isSet('email')) {
    <div class="recovery-done-banner">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
        stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <circle cx="12" cy="12" r="10" />
        <path d="m8.5 12.5 2.5 2.5 5-5.5" />
      </svg>
      <span>Email has been verified</span>
    </div>
    } @else if (!recovery.otpStage) {
    <div class="form-group">
      <label for="recEmail">Email</label>
      <app-phil-input [control]="emailControl" placeholder="Enter your email" type="email"></app-phil-input>
    </div>
    <button type="button" class="login-btn" [disabled]="isLoading" (click)="otpSent.emit()">
      @if (isLoading) {
      <span class="spinner" role="status" aria-label="Loading"></span>
      } @else { Send OTP }
    </button>
    } @else {
    <div class="form-group">
      <label for="recOtpEmail">Enter OTP sent to {{ recovery.otpSentTo }}</label>
      <input id="recOtpEmail" type="text" formControlName="otp" maxlength="6" placeholder="Enter OTP"
        (keypress)="allowOnlyDigits($event)" style="text-transform: none" />
    </div>
    <button type="button" class="login-btn" [disabled]="isLoading" (click)="otpVerified.emit()">
      @if (isLoading) {
      <span class="spinner" role="status" aria-label="Loading"></span>
      } @else { Verify OTP }
    </button>
    <div class="resend-text">
      <span class="resend-link" (click)="otpCancelled.emit()">Change email</span>
    </div>
    }
    }

    @if (recovery.step === 3) {
    @if (isSet('phone')) {
    <div class="recovery-done-banner">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
        stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <circle cx="12" cy="12" r="10" />
        <path d="m8.5 12.5 2.5 2.5 5-5.5" />
      </svg>
      <span>Alternate number has been verified</span>
    </div>
    } @else if (!recovery.otpStage) {
    <div class="form-group">
      <label for="recPhone">Alternate phone number</label>
      <app-phil-input [control]="phoneControl" placeholder="Enter alternate phone number" type="tel"
        [pattern]="0" [attributes]="{ maxlength: 15 }"></app-phil-input>
    </div>
    <button type="button" class="login-btn" [disabled]="isLoading" (click)="otpSent.emit()">
      @if (isLoading) {
      <span class="spinner" role="status" aria-label="Loading"></span>
      } @else { Send OTP }
    </button>
    } @else {
    <div class="form-group">
      <label for="recOtpPhone">Enter OTP sent to {{ recovery.otpSentTo }}</label>
      <input id="recOtpPhone" type="text" formControlName="otp" maxlength="6" placeholder="Enter OTP"
        (keypress)="allowOnlyDigits($event)" style="text-transform: none" />
    </div>
    <button type="button" class="login-btn" [disabled]="isLoading" (click)="otpVerified.emit()">
      @if (isLoading) {
      <span class="spinner" role="status" aria-label="Loading"></span>
      } @else { Verify OTP }
    </button>
    <div class="resend-text">
      <span class="resend-link" (click)="otpCancelled.emit()">Change number</span>
    </div>
    }
    }

    @if (recovery.error) {
    <small class="error-text">{{ recovery.error }}</small>
    }
  </form>

  <div class="recovery-footer">
    @if (recovery.step < 3 && !recovery.otpStage) {
    <button type="button" class="recovery-skip-btn" [disabled]="isLoading" (click)="skipped.emit()">
      Skip
    </button>
    }
    <button type="button" class="login-btn" [disabled]="isLoading || !anySet()" (click)="finished.emit()">
      @if (isLoading) {
      <span class="spinner" role="status" aria-label="Loading"></span>
      } @else { Continue }
    </button>
  </div>
</div>